<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 500; font-size: 28px;" class="ml-4">{{ $t("GenerateTestQuestions_title") }}</h1>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              <div class="custom-search-input-wrapper">
                    <div class="custom-search-input-container">
                      <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                      <input id="documentname-field-uploadsoundtodocument" type="text" :placeholder="$t('questionSet')"
                        :aria-label="$t('questionSet')"
                        class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                      <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                        @click="searchName = ''">
                        mdi-close-circle
                      </v-icon>
                    </div>
                  </div>
              
                <!-- Refresh Button -->
                <v-btn
                  id="button-refresh-validationgenerate"
                  color="#C9C9C9"
                  class="control-btn refresh-btn"
                  variant="outlined"
                  size="large"
                  density="comfortable"
                  @click="ManualRefresh()"
                  icon
                >
                  <v-icon size="24">mdi-refresh</v-icon>
                  <v-tooltip activator="parent" location="top">
                    {{ $t("refresh") }}
                  </v-tooltip>
                </v-btn>
                
                <!-- Add Button -->
                <v-btn
                  id="button-add-validationgenerate"
                  color="primary"
                  class="control-btn create-btn customadd"
                  variant="flat"
                  size="large"
                  prepend-icon="mdi-plus"
                  rounded="xl"
                  @click="Upload()"
                >
                  {{ $t("add") }}
                <v-tooltip activator="parent" location="top">{{ $t("_addNewQuestionSet") }}</v-tooltip>
                </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
          class="pa-5"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: left">{{ item.number }}</td>
              <td style="text-align: left">{{ item.name }}</td>
              <td style="text-align: left">
                <!-- Process Status with compact design -->
                  <div class="status-container">
                    <v-chip :color="getProcessStatusColor(item)" variant="flat" size="small" class="status-chip">
                      <v-icon start size="14">
                        {{ getProcessStatusIcon(item) }}
                      </v-icon>
                      <span class="status-text">{{ getProcessStatusText(item) }}</span>
                    </v-chip>
                  </div>
              </td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: center">
                <div class="action-container">
                  <div class="action-group">
                    <!-- เดิม :disabled="item.inProcess >= item.inProcessMax && !item.isError" ซึ่งอ้าง field ที่ API ไม่เคยส่ง
                         undefined >= undefined เป็น false ปุ่มจึงเปิดตลอด "โดยบังเอิญ"
                         ต้องเอาออกให้ชัด ไม่งั้นวันไหนมี field ชื่อนี้โผล่มาจริง guard จะกลับมาทำงาน
                         แล้วล็อกปุ่มกู้คืนบนแถวที่ต้องใช้มันที่สุด
                         Reprocess ต้องกดได้เสมอ รวมถึงตอนที่ยังทำงานอยู่ โดยมีคำเตือนใน dialog แทน -->
                    <v-btn :id="'button-reprocess-validationgenerate'" variant="flat" size="small"
                      @click="Reprocess(item)" class="minimal-btn" icon>
                      <img :src="images.reprocess" alt="Reprocess" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        {{ $t("reprocess") }}
                      </v-tooltip>
                    </v-btn>
                    <!-- Edit -->
                    <v-btn
                      id="button-edit-validationgenerate"
                      variant="text"
                      density="comfortable"
                      class="action-btn edit-btn"
                      icon
                      @click="EditValidationGenerate(item)"
                    >
                      <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        {{ $t("edit") }}
                      </v-tooltip>
                    </v-btn>
                    
                    <!-- Download -->
                    <v-btn
                      id="button-download-validationgenerate"
                      variant="text"
                      density="comfortable"
                      class="action-btn download-btn"
                      icon
                      @click="Download(item.generateID)"
                      :disabled="item.status != 'success'"
                    >
                      <img :src="images.download" alt="Download" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        {{ $t("Download") }}
                      </v-tooltip>
                    </v-btn>
                  
                    <!-- Delete -->
                    <!-- เดิม :disabled="item.status === 'Processing'" ซึ่งล็อกปุ่มถาวรบนแถวที่ค้าง
                         ชุดคำถามถูกสร้างมาพร้อมสถานะ Processing (ValidationGenerateBAL) แล้วจะได้สถานะจบ
                         ก็ต่อเมื่องานเบื้องหลังทำจนจบ ถ้า app restart / thread ตาย / exception หลุด
                         สถานะจะค้าง Processing ตลอดกาล แล้วตารางนี้ไม่มีกลไกกู้สถานะแบบที่ ValidationProcess มี
                         = แถวลบไม่ออกถาวร ทั้งที่ Delete คือทางออกเดียวที่ผู้ใช้มี
                         (ผลข้างเคียงเดิม: กด Reprocess จะตั้งสถานะเป็น Reprocess ซึ่ง guard ไม่ครอบ
                          ปุ่มจึงกลับมากดได้ = ต้องจุด LLM รันใหม่ทั้งชุดเพื่อจะลบทิ้ง)
                         การลบระหว่างรันปลอดภัยอยู่แล้ว DeleteValidationGenerate ตั้ง Activeflag = false
                         แล้ว IsGenerateActiveAsync ที่ probe ก่อนทุกก้อนจะหยุด loop ให้เอง -->
                    <v-btn
                      id="button-delete-validationgenerate"
                      variant="text"
                      density="comfortable"
                      class="action-btn delete-btn"
                      icon
                      @click="DeleteValidate(item)"
                    >
                      <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        {{ $t("delete") }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>
           <!-- Custom footer area -->
          <template v-slot:bottom>
            <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
              <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

              <v-data-table-footer v-model:items-per-page="itemsPerPage" :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)" />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t("loading") }}</h3>
          <p class="loading-subtitle">{{ $t("pleaseWait") }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t("deleteConfirmation") }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span style="font-weight: 500;" v-if="deleteItem">
            {{ $t("_confirmDeleteQuestionSet") }}
          </span>
          <!-- ตั้งแต่ถอด :disabled ออก ปุ่มนี้กดได้ระหว่างที่งานยังวิ่งอยู่
               ต้องบอกให้ชัดว่ากดแล้วงานที่กำลังทำจะถูกหยุด ไม่ใช่แค่ซ่อนแถวออกจากตาราง -->
          <div class="mt-2 text-warning" v-if="deleteSource && isRunning(deleteSource.status)">
            {{ $t("deleteRunningWarning") }}
          </div>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <img :src="images.deleteIcon" width="20" height="20" alt="Delete" />
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Warning Dialog -->
    <v-dialog v-model="dialog_warn" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="warn-dialog-header">
          <span class="reprocess-dialog-title">{{ $t("reprocessingQuestionSet") }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="dialog_warn = false"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
            {{ $t("_Reprocess") }}
            <!-- ข้อสันนิษฐานเดิมของคอมเมนต์ตรงนี้ผิด: ปุ่ม Reprocess ของเมนูนี้ไม่ได้เรียก
                 Questions_ReProcess_file (เมธอดนั้นเป็น dead code ไม่มีใครเรียกทั้ง repo)
                 มันเรียก CreateValidationGenerateReprocess ซึ่งปิด Activeflag ของชุดเดิมแล้วสร้าง
                 GenerateID ใหม่ — พฤติกรรมเดียวกับเมนู Execute Test Runs เป๊ะ
                 งานเดิมจึงถูกยกเลิกจริงที่ขอบ chunk ถัดไป ไม่ได้วิ่งซ้อน -->
            <div class="mt-2 text-warning" v-if="reprocessSource && isRunning(reprocessSource.status)">
              {{ $t("reprocessConcurrentRunWarning") }}
            </div>
        </v-card-text>
        
        <!-- Actions -->
        <!-- เดิมมีแค่ปุ่ม Yes บน dialog แบบ persistent ทางออกเดียวคือกากบาทมุมบน
             ทั้งที่ Reprocess จะปิด question set เดิมแล้วเริ่มใหม่ทั้งชุด
             จัดลำดับปุ่มให้ตรงกับ dialog Delete ที่อยู่ติดกัน (ปุ่มปลอดภัยอยู่ซ้าย) -->
        <v-card-actions class="delete-dialog-actions">
          <!-- ใช้ .delete-cancel-btn ซึ่งเป็น global class เดียวกับที่ dialog Delete ใช้อยู่
               ปุ่ม Cancel ของสอง dialog ที่อยู่ติดกันจะได้หน้าตาเหมือนกันจริง -->
          <v-btn
            class="delete-cancel-btn"
            @click="dialog_warn = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            class="reprocess-confirm-btn"
            @click="confirmReprocess()"
          >
            {{ $t("yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo, { default as LogTrace } from "@/api/function.js"; // NOSONAR
import editImg from "@/assets/images/editbutton.png";
import deleteImg from "@/assets/images/trashbutton.png";
import reprocessImg from "@/assets/images/Reprocess.png";
import downloadImg from "@/assets/images/downloadnew.png";
import deleteIcon from "@/assets/images/trash-solid.svg";
export default {
  name: "ValidationGenerate",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    loadingTable: false,
    searchName: "",
    isFirst: true,
    // คุม polling: กัน loop ซ้อน, หยุดเมื่อออกจากหน้า และตัด response ที่มาช้ากว่าคำขอล่าสุด
    autoRefreshRunning: false,
    autoRefreshStopped: false,
    tableReqSeq: 0,
    checkbox1: false,
    dialog: false,
    today: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    images: {
      edit: editImg,
      delete: deleteImg,
      reprocess: reprocessImg,
      download: downloadImg,
      deleteIcon: deleteIcon,
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    sortBy: [],
    sortDesc: [],
    dialog_delete: false,
    deleteItem: null,
    // แถวที่กำลังจะลบ เก็บไว้เพื่อดูสถานะตอนแสดงคำเตือนใน dialog
    deleteSource: null,
    dialog_warn: false,
    reprocessSource: null,
  }),
  computed: {
    headers() {
      return [
        { title: this.$t("no"), align: "left", sortable: false },
        { title: this.$t("questionSet"), align: "left", sortable: true, value: "Name" },
        {
          title: this.$t("processStatus"),
          align: "left",
          sortable: true,
          value: "ImportedDataCount",
        },
        {
          title: this.$t("createdBy"),
          align: "left",
          sortable: true,
          value: "CreateBy",
        },
        { title: this.$t("manage"), align: "center", sortable: false },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // เดิมชุดฟังก์ชันนี้อ้าง item.inProcess / item.inProcessMax ซึ่ง API ของหน้านี้ไม่เคยส่งมา
    // undefined === undefined เป็น true เสมอ → ทุกแถวเขียวติ๊กถูกตลอด ไม่ว่าจะกำลังทำ พัง หรือเสร็จ
    // สาขา warning/grey จึงเป็น dead code ฟังก์ชันชุดนี้ถูกก๊อปมาจากหน้าอื่นที่มี field พวกนั้นจริง
    isRunning(status) {
      return status === "Processing" || status === "Reprocess";
    },
    isErrorStatus(status) {
      return typeof status === "string" && status.startsWith("error");
    },
    num(v) {
      const n = parseInt(v, 10);
      return isNaN(n) || n < 0 ? 0 : n;
    },
    // ประมวลผลก้อนไปแล้วแต่ไม่ได้คำถามที่ใช้ได้เลยสักข้อ
    producedNothing(item) {
      return this.num(item.chunkDone) > 0 && this.num(item.producedQuestions) === 0;
    },
    // จำนวนก้อนที่ไม่ได้คำถามเลย (-1 = backend วัดไม่ได้บนเส้นทางนี้)
    missingChunks(item) {
      const n = parseInt(item && item.chunksWithoutQuestions, 10);
      return isNaN(n) ? -1 : n;
    },
    // มีเนื้อหาบางก้อนที่ไม่มีคำถามครอบคลุมเลย = ปัญหาคุณภาพจริง
    //
    // ห้ามใช้ "ได้น้อยกว่าเป้า" มาเป็นเกณฑ์เตือนเด็ดขาด — ช่อง Questions Per Chunk เป็น "เพดาน"
    // (tooltip ในฟอร์มเขียนเองว่า maximum) โมเดลตอบ 1 ข้อแทน 2 จึงเป็นเรื่องปกติ
    // ถ้าเตือนทุกครั้งที่ไม่เต็มเพดาน chip จะเตือนแทบตลอดเวลาแล้วคนก็เลิกมอง
    // ซึ่งอันตรายพอ ๆ กับตอนที่มันเขียวติ๊กถูกตลอดจนไม่มีใครเห็นว่าพัง
    hasCoverageGap(item) {
      return this.missingChunks(item) > 0 || this.producedNothing(item);
    },
    // สีส้มสงวนไว้ให้ "กำลังทำงาน" เท่านั้น ตามที่ผู้ใช้คาดหวัง
    // งานที่จบแล้วแต่มีปัญหาจึงต้องใช้สีอื่น ไม่งั้นผู้ใช้จะอ่านว่า "ยังทำไม่เสร็จ"
    getProcessStatusColor(item) {
      if (this.isRunning(item.status)) return "warning";
      if (this.isErrorStatus(item.status) || this.hasCoverageGap(item)) return "error";
      return "success";
    },

    getProcessStatusIcon(item) {
      if (this.isRunning(item.status)) return "mdi-clock-outline";
      if (this.isErrorStatus(item.status) || this.hasCoverageGap(item)) return "mdi-alert-circle-outline";
      return "mdi-check-circle-outline";
    },

    // ข้อความบน chip
    // ความคืบหน้าใช้หน่วยเดียวกันทั้งเศษและส่วน (chunk) จึงเต็ม 100% เสมอเมื่อจบงาน
    // ต่างจากเดิมที่เป็น "คำถามที่ผลิตได้ / เป้าที่ตั้งไว้ตอนกดสร้าง" ซึ่งไม่มีวันเท่ากัน
    // ส่วนผลผลิตแยกไปต่อท้าย เพราะเป็นคนละคำถามกับความคืบหน้า
    getProcessStatusText(item) {
      const done = this.num(item.chunkDone);
      const total = this.num(item.chunkTotal);
      const produced = this.num(item.producedQuestions);
      const missing = this.missingChunks(item);

      // ยังไม่มีข้อมูล chunk (แถวเก่าที่ยังไม่ได้ seed หรือ response เก่า) → ถอยไปใช้ค่าเดิม
      if (total === 0) return item.result;

      const progress = `${done}/${total} ${this.$t("chunkUnit")}`;
      if (this.isRunning(item.status)) return progress;

      // เลิกแสดง "(เป้า N)" เพราะเป้าเป็นเพดาน ไม่ใช่โควตา การเห็นตัวเลขไม่ถึงเป้าทำให้เข้าใจผิดว่างานไม่เสร็จ
      // สิ่งที่ผู้ใช้ต้องตัดสินใจได้จริงคือ "เนื้อหาถูกครอบคลุมครบไหม" จึงแสดงจำนวนก้อนที่ขาดแทน
      const parts = [progress];

      // จำนวนโทนอธิบายว่าทำไมคำถามถึงมากกว่าจำนวนก้อนหลายเท่า (แต่ละก้อนถูกถามซ้ำทุกโทน)
      // ไม่มีบรรทัดนี้ผู้ใช้จะเห็น "22 ก้อน ได้ 176 คำถาม" แล้วหาที่มาของตัวคูณไม่เจอ
      const tones = this.num(item.toneCount);
      if (tones > 1) parts.push(`${tones} ${this.$t("toneUnit")}`);

      parts.push(`${produced} ${this.$t("questionUnit")}`);

      // ถ้าก้อนที่ขาดเกิดจากเรียกโมเดลไม่สำเร็จ ให้บอกตรง ๆ เพราะเป็นคนละปัญหากับ "โมเดลตอบไม่ครบ"
      // อันหนึ่งต้องไปดู quota/endpoint อีกอันต้องไปปรับ prompt — ผู้ใช้ต้องแยกออกได้จากหน้าจอ
      const llmFailed = this.num(item.chunkLlmFailed);
      if (llmFailed > 0) parts.push(this.$t("chunksLlmFailed", { count: llmFailed }));
      else if (missing > 0) parts.push(this.$t("chunksNoQuestion", { count: missing }));

      return parts.join(" · ");
    },
    Refresh() {
      this.EditdialogUser = false;
    },
    Search() {
      this.dialog = true;
      this.isSearch = true;
      this.options.page = 1;
      this.Get();
    },
    Upload() {
      this.$router.push({
        name: "ValidationGenerateUpload",
      });
    },
    EditValidationGenerate(item) {
      this.$router.push({
        name: "ValidationGenerateUpload",
        query: {
          id: item.generateID,
        },
      });
    },
    // payload กลางของตาราง ใช้ร่วมกันทั้ง Get() และ ReFreshGet()
    //
    // เดิม ReFreshGet สร้าง payload เองโดยมีแค่ page/perPage → ทิ้ง name/sortBy/sortDesc
    // ผลคือทุกครั้งที่กดปุ่ม Refresh หรือ polling ทำงาน ตารางที่ผู้ใช้ค้นหาไว้จะถูกแทน
    // ด้วยผลลัพธ์ที่ไม่ได้กรอง ขณะที่ช่องค้นหายังแสดงคำค้นเดิมอยู่ ดูเหมือน filter พัง
    buildTableRequest() {
      if (this.searchName == null) {
        this.searchName = "";
      }
      const { page, itemsPerPage } = this.options;
      this.sortBy =
        this.options.sortBy == undefined || this.options.sortBy.length == 0
          ? null
          : this.options.sortBy[0];
      this.sortDesc =
        this.options.sortDesc == undefined || this.options.sortDesc.length == 0
          ? null
          : this.options.sortDesc[0];
      return {
        name: this.searchName,
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : this.totalTable, // NOSONAR
        sortDesc: this.sortDesc,
        sortBy: this.sortBy,
      };
    },
    // แถวที่ยังทำงานอยู่จริงหรือไม่ ใช้ตัดสินว่าจะ poll ต่อ
    // เดิมใช้ `if (this.sortDesc == null)` ซึ่ง **เป็นจริงเสมอ** เพราะ Vuetify 3 ไม่เติม
    // options.sortDesc อีกแล้ว (ใช้ sortBy: [{key, order}] แทน) ค่าจึงเป็น [] ตลอด
    // แล้วบรรทัดบนก็แปลง [] เป็น null → AutoRefresh ถูกปลุกทุกครั้งที่โหลดตาราง
    // (เปลี่ยนหน้า ค้นหา เปลี่ยนจำนวนต่อหน้า) และไม่มี guard กัน loop ซ้อน
    hasInProgressRow() {
      return (this.dataTable || []).some((row) => {
        if (!row || typeof row.result !== "string") return false;
        if (row.status !== "Reprocess" && row.status !== "Processing") return false;
        const parts = row.result.split("/");
        const done = Number.parseInt(parts[0], 10);
        const total = Number.parseInt(parts[1], 10);
        if (Number.isNaN(done) || Number.isNaN(total)) return false;
        return done < total;
      });
    },
    Get() {
      this.loadingTable = true;
      const temp = this.buildTableRequest();
      const myReq = ++this.tableReqSeq;
      this.$call.GetTableValidationGenerate(
        temp,
        (dataResponse) => {
          // ทิ้ง response ที่มาช้ากว่าคำขอล่าสุด ไม่งั้นผลของคำค้นเก่าจะทับผลใหม่
          if (myReq !== this.tableReqSeq) {
            return;
          }
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
            this.AutoRefresh();
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.dialog = false;
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.loadingTable = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    ReFreshGet() {
      const temp = this.buildTableRequest();
      // อ่านค่าเฉย ๆ ห้าม ++ — guard ต้องเป็นทางเดียว
      // Get() ของผู้ใช้ทำให้ poll เก่าตกไปได้ แต่ poll ต้องไม่ทำให้ Get() ตกไป
      // ไม่งั้น loadingTable = false ใน callback ของ Get() จะไม่ถูกเรียก แล้ว overlay ค้าง
      const myReq = this.tableReqSeq;
      return new Promise((resolve) => {
        this.$call.GetTableValidationGenerate(
          temp,
          (dataResponse) => {
            if (myReq === this.tableReqSeq) {
              if (dataResponse.status == 0) {
                this.searchTotalTable = dataResponse.data.total;
                this.dataTable = dataResponse.data.data;
                this.totalTable = this.isFirst
                  ? dataResponse.data.total
                  : this.totalTable;
              } else {
                this.dataTable = [];
                this.searchTotalTable = 0;
                this.totalTable = 0;
              }
              this.dialog = false;
              this.isSearch = false;
              this.isFirst = false;
            }
            resolve(dataResponse.status == 0);
          },
          (errorResource) => {
            this.dialog = false;
            this.isSearch = false;
            console.error(errorResource);
            resolve(false);
          }
        );
      });
    },
    // ปุ่ม Refresh บนหัวตาราง — ต้องปลุก polling กลับมาด้วย
    // ถ้า AutoRefresh หยุดไปเพราะล้มติดกัน 3 ครั้ง ปุ่มนี้คือสิ่งแรกที่ผู้ใช้กด
    async ManualRefresh() {
      await this.ReFreshGet();
      this.autoRefreshStopped = false;
      this.AutoRefresh();
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event; // NOSONAR
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]); // NOSONAR
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
      };
    },
    ValidateCSVVector(csv, files) {
      let temp = csv.replaceAll("\r", "");
      let lines = temp.split("\n");
      if (lines[0] != "text_org,text_en") { // NOSONAR
        alert("Please Enter Correct Format!");
      } else {
        const formDataDoc = new FormData();
        formDataDoc.append("entity", files[0]);
      }
    },
    resourceResult(result) {
      if (result != "") {
        let arr = result.split("/");
        if (arr.length == 2) {
          return "0/" + arr[1];
        }
      }
      return result;
    },

    Reprocess(source) {
      this.dialog_warn = true;
      this.reprocessSource = source;
    },
    confirmReprocess() {
      this.dialog_warn = false;
      const source = this.reprocessSource;
      this.dialog = true;
            this.loading = true;
            this.$call.ReprocessValidationGenerate(
              source.generateID,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  source.status = "Reprocess";
                  source.result = this.resourceResult(source.result);
                  this.$swal.fire({
                    title: this.$t("_successfullyReprocessed"),
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                  });
                  this.AutoRefresh();
                } else {
                  // backend ปฏิเสธไปแล้ว (ชุดถูกลบ / มีคนกดทับ / ไม่มี chunk ให้ทำ)
                  // เดิม controller ตอบ Successful เสมอจนสาขานี้ไม่มีทางเข้าถึง หน้าจอจึงขึ้นว่า
                  // เริ่มรอบใหม่สำเร็จทั้งที่ไม่มีอะไรเกิดขึ้น — ต้องบอกความจริงและรีเฟรชให้เห็นสถานะล่าสุด
                  this.$swal.fire({
                    icon: "warning",
                    title: this.$t("_reprocessNotStarted"),
                    showConfirmButton: false,
                    timer: 2500,
                    position: 'top',
                  });
                  this.ManualRefresh();
                }
                this.loading = false;
                this.dialog = false;
              },
              (errorResource) => {
                this.dialog = false;
                this.Adddialog = false;
                console.error(errorResource);
              }
            );
    },
    Download(id) {
      this.dialog = true;
      this.loading = true;
      this.$call.DownloadCSVQuestions(
        id,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = globalThis.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            let fileName = `Questions_${this.convertDateToString(
              new Date(),
              ""
            )}.csv`;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);

            fileLink.click();

            // Show success message
            this.$swal.fire({
              title: this.$t("_successfullyDownloaded"),
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    // รับทั้งแถวไม่ใช่แค่ id เพราะ dialog ต้องรู้สถานะเพื่อตัดสินใจว่าจะขึ้นคำเตือน "งานกำลังรัน" ไหม
    DeleteValidate(item) {
      this.deleteItem = item.generateID;
      this.deleteSource = item;
      this.dialog_delete = true;
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
      this.deleteSource = null;
    },
    confirmDelete() {
      if (!this.deleteItem) return;
      const id = this.deleteItem
      this.dialog = true;
      this.loading = true;
      this.$call.DeleteValidationGenerate(
        id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.dialog_delete = false;
            this.deleteItem = null;
            this.deleteSource = null;
            this.$swal.fire({
              title: this.$t("_successfullyDeleted"),
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            this.Get();
          }
          this.loading = false;
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.Adddialog = false;
          console.error(errorResource);
        }
      );
    },
    checkForLoop(data) {
      for (let value of data) {
        let totalSp = value.result.split("/");
        let total = Number.parseInt(totalSp[0]);
        let total2 = Number.parseInt(totalSp[1]);
        if (
          total < total2 &&
          (value.status == "Reprocess" || value.status == "Processing")
        ) {
          return false;
        }
      }
      return true;
    },
    async AutoRefresh() {
      // กัน loop ซ้อน: เดิมไม่มี guard และ Get() ปลุก AutoRefresh ทุกครั้งที่โหลดตาราง
      // จึงได้ loop ขนานเพิ่มขึ้นเรื่อย ๆ ที่ยิง API ทุก 5 วินาทีพร้อมกันทั้งหมด
      if (this.autoRefreshRunning) return;
      this.autoRefreshRunning = true;
      let consecutiveFailures = 0;
      try {
        while (!this.autoRefreshStopped && this.hasInProgressRow()) {
          await new Promise((resolve) => setTimeout(resolve, 5000));
          if (this.autoRefreshStopped) break;
          const ok = await this.ReFreshGet();
          if (ok) {
            consecutiveFailures = 0;
          } else {
            consecutiveFailures += 1;
            // endpoint ล้มติดกัน 3 ครั้ง — หยุด แทนที่จะยิง error popup ทุก 5 วินาทีไม่รู้จบ
            if (consecutiveFailures >= 3) break;
          }
        }
      } finally {
        this.autoRefreshRunning = false;
      }
    },
  },
  beforeUnmount() {
    this.autoRefreshStopped = true;
  },
  deactivated() {
    this.autoRefreshStopped = true;
  },
  activated() {
    this.autoRefreshStopped = false;
    this.AutoRefresh();
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 200px;
}
.refresh-btn {
  margin-left: 9px;
  color: black !important;
  border-radius: 50% !important;
  border: 1px solid #c6c6c6 !important;
}

.refresh-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06) !important;
}

.download-btn[disabled] {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.38) !important;
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* action disable button delete */
.delete-btn:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  background-color: rgba(244, 67, 54, 0.388) !important;
  pointer-events: none !important;
}

.delete-btn:disabled .v-icon {
  color: rgba(244, 67, 54, 0.5) !important;
}

.delete-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: rgba(244, 67, 54, 0.1) !important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
</style>
